import { Component, OnInit } from '@angular/core';
import { ManageChildHeadersService } from './../../Common/Services/manage-child-headers.service';
import { Utility } from './../../Common/Services/utility';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AppMessage } from './../../Common/appMessage';
import { AppGlobals } from './../../Common/Services/app.global';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})

export class PageNotFoundComponent implements OnInit {
  headerStatus: number;
  imgSrc: string;
  headerStr: string;
  msgStr: string;
  logoutURL: string = "";
  rhId: string = "";
  isUserLoggedIn: boolean = false;
  note: string;

  constructor(private _manageChildHeadersService: ManageChildHeadersService, private _utility: Utility, private _appGlobals: AppGlobals
    , private _router: Router, private _appMessage: AppMessage, private _activatedRoute: ActivatedRoute) { }

  /**
   * If Token is invalid then display access denied page with link.  Else redirect to login page
   */
  ngOnInit() {
    this._utility.clearLoaderCount(); // Clear loader count so that loader should not display for this page at any way
    if (!this._appGlobals.isInvalidToken && location.pathname.length > 1) { // location.pathname.length -- for production site it's length is greater then 1 . So condition is required for local.
      location.pathname += 'services/externaluser/login'; // redirect to external user if incomplete URL
      this._appGlobals.isInvalidToken = true;
      return;
    }
    this.headerStatus = 0;
    this._manageChildHeadersService.setHeaderStatus(this.headerStatus);
    let headerStr = "Access Denied";
    let imgSrc = "./assets/images/accessDenied.png";
    this.logoutURL = this._appGlobals.logoutURL.getValue();
    this.isUserLoggedIn = this._appGlobals.isUserLoggedIn.getValue();
    this.rhId = this._appGlobals.userAttemptingToLogin.getValue();
    this.note = this._appMessage.getItem["UMsg00090"];

    // Based on error code , fetch message from app message and display on UI , If No error code found at our AppMessage file then display "UMsg00075" this code message
    this._activatedRoute.params.subscribe((params: Params) => {
      let errorId = params['eid']; // error code Id
      let errorMsg = (errorId && errorId != null && errorId != "") ? this._appMessage.getItem[errorId] : this._appMessage.getItem["UMsg00075"];
      this.msgStr = errorMsg;
      this.imgSrc = imgSrc;
      this.headerStr = headerStr;
    });
  }
}




// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/page-not-found/page-not-found.component.ts